import { apiService } from './api';

// The billing-address link page's calls. The token rides in a header - never
// the URL or the body, both of which end up in server logs - and a dead link
// answers 410, so the 401 re-authentication handler is never involved.
const TOKEN_HEADER = 'X-Address-Link-Token';
const NO_AUTH_HANDLER = { skipAuthHandler: true };

export const addressLinkService = {
  getContext: (token) => apiService.post(
    'view/address-link/context',
    {},
    { [TOKEN_HEADER]: token },
    NO_AUTH_HANDLER,
  ),
  saveAddress: ({ token, address }) => apiService.post(
    'view/address-link/address',
    { address },
    { [TOKEN_HEADER]: token },
    NO_AUTH_HANDLER,
  ),
};

export default addressLinkService;
